<p *ngIf="label" class="mat-body-1" [translate]="label"></p>
<div [class]="'gb-range-slider-container ' + cssClass">
  <input
    type="range"
    class="slider"
    [min]="min"
    [max]="max"
    step="1"
    [formControl]="control"
    [class.touch]="isTouch"
    #slider
  />
  <div class="slider-track"></div>
  <div class="slider-progress" [style.width]="progress + '%'"></div>
</div>
